import React from 'react';
import { Body } from '@edreamsodigeo/prisma-design-system';
import { Trans } from '@edreamsodigeo/frontend-core';
import { PriceStyle } from '../PriceStyle';

export const NeedAppSubtitleBoldStyle = ({ type, content }) => {
  return (
    <Body inline type={type} weight="medium">
      {content}
    </Body>
  );
};

export const MoreInfoBannerParag1Subtitle = ({ cap }) => {
  return (
    <Trans
      i18nKey="pricefreeze.moreinfo.coverage.trip.subtitle"
      components={{ price: <PriceStyle money={cap} rounded /> }}
    />
  );
};
